export default function triggerBrowserReflow(element) {
  // eslint-disable-next-line no-unused-expressions
  element.offsetHeight;
}